var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var alertContainerStyles = function (theme) {
    return {
        // Non-Portal Alert
        '& .alert-content > p': __assign(__assign({}, theme.typography.body2), { letterSpacing: 0 }),
        '& .alert-content bold, .alert-content strong': {
            fontWeight: theme.typography.fontWeightMedium,
        },
        '& .alert-content > p > a': {
            fontWeight: theme.typography.fontWeightMedium,
            color: theme.palette.text.primary,
        },
        '& .alert-content > p > a:hover': {
            textDecoration: 'none',
        },
        '& code .alert-content': __assign({}, theme.typography.code1),
        // These styles are extracted from
        // https://github.com/mui-org/material-ui/blob/v4.9.8/packages/material-ui-lab/src/Alert/Alert.js#L18
        '& .QuantumAlert-root': __assign(__assign(__assign({}, theme.typography.body2), { borderRadius: theme.shape.borderRadius, backgroundColor: 'transparent', display: 'flex', padding: '6px 16px' }), {
            '& a': {
                fontWeight: theme.typography.fontWeightMedium,
                color: theme.palette.text.primary,
            },
            '& a:hover': {
                textDecoration: 'none',
            },
        }),
        '& .QuantumAlert-icon': {
            marginRight: 12,
            padding: '7px 0',
            display: 'flex',
            opacity: 0.9,
            fontSize: theme.typography.pxToRem(20),
            '& svg': {
                height: '1em',
                width: '1em',
            },
        },
        '& .QuantumAlert-message': {
            padding: '8px 0',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            overflowX: 'auto',
            scrollBehavior: 'smooth',
            webkitOverflowScrolling: 'touch',
        },
        '& .alert-portal-severity-default': {
            // Copy from https://github.com/auth0/manhattan/blob/81de5cbcfb3eb3bcb0961dd4d9e28caa0360a77f/quantum-product/src/alert/alert.tsx#L28
            borderLeft: "8px solid ".concat(theme.mixins.shadeOfColor('neutral', 'base')),
            color: theme.mixins.textColorForShadeOfColor('neutral', 'lightest'),
            backgroundColor: theme.mixins.shadeOfColor('neutral', 'lightest'),
            '& $icon': {
                color: theme.mixins.textColorForShadeOfColor('neutral', 'lightest'),
            },
        },
        '& .QuantumAlert-standardWarning,  & .alert-portal-severity-warning': {
            backgroundColor: theme.tokens.color_bg_state_caution_subtle,
            '& $icon': {
                color: theme.tokens.color_fg_state_caution,
            },
        },
        '& .QuantumAlert-standardInfo,  & .alert-portal-severity-info': {
            backgroundColor: theme.tokens.color_bg_state_info_subtle,
            '& $icon': {
                color: theme.tokens.color_fg_state_info,
            },
        },
        // Custom styles
        '& .alert-portal-content': {
            '&:last-child': {
                marginBottom: 0,
            },
            '& p': __assign(__assign({}, theme.typography.body2), { letterSpacing: 0, '&:last-child': {
                    marginBottom: 0,
                } }),
            '& code': __assign(__assign({}, theme.typography.code1), { paddingLeft: 3, paddingRight: 3 }),
            '& bold, & strong, & b': {
                fontWeight: theme.typography.fontWeightMedium,
                fontSize: theme.typography.body2.fontSize,
            },
        },
    };
};
